"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    key: _vm.url,
    staticClass: "kiwi-mediaviewer-embedly"
  }, [_vm.url && !_vm.invidiousInstances.some(function (instance) {
    var _context;
    if ((0, _includes.default)(_context = _vm.url).call(_context, instance)) {
      return true;
    }
    return false;
  }) ? _c('a', {
    ref: "embedlyLink",
    staticClass: "kiwi-embedly-card",
    attrs: {
      "href": _vm.url,
      "data-card-key": _vm.settings.key,
      "data-card-width": _vm.cardWidth,
      "data-card-chrome": "0",
      "data-card-controls": "0",
      "data-card-recommend": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('media_loading', {
    url: _vm.url
  })))]) : _c('iframe', {
    staticClass: "kiwi-embedly-card",
    attrs: {
      "src": _vm.url,
      "frameborder": "0"
    }
  })]);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;